module.exports = __webpack_public_path__ + "img/P150T_weapon_137.232cc9f0.png";